/**
 * ÜYE LİSTESİNİN DURUMU — "yetkin yok" ile "kimse yok" ayrımı.
 *
 * Kartlar: CLOS-155 `[148]` · CLOS-158 `[151]` · CLOS-161 `[154]` · CLOS-165 `[158]` ·
 * CLOS-247 `[135]` — altı seçim ekranının hepsi aynı kusurdan etkileniyordu, bileşen
 * beşinin ortak düzeltmesi olarak doğdu (`275ecf5`). Referans CLOS-845 ile yazıldı:
 * bileşen web'de kart bağı olmayan tek ürün bileşeniydi ve ADR-0014 altında bu, ona
 * bakan bir sonraki kişinin "bu neden var?" sorusuna cevapsız kalması demekti.
 *
 * ### ⚠ Boş liste iki farklı şeyin cevabı olabilir
 *
 * `GET /api/tenants/:id/members` `organization.member` yetkisi istiyor. Yetkisi olmayan
 * kullanıcıda sorgu 403 dönüyor, `data` boş kalıyor ve ekranlar bunu sessizce "seçilecek
 * kimse yok" gibi gösteriyordu: inceleyici, onaylayıcı, mutabakat temsilcisi, imzacı,
 * sorumlu ve portföy sorumlusu seçimlerinin altı bomboş çıkıyor, kullanıcı neden kimseyi
 * seçemediğini hiçbir yerde okuyamıyordu (kusur avı, 26 Ağustos).
 *
 * Erişimsizlik yokluk değildir: liste boş çünkü SORULAMADI. İki durum iki ayrı cümle.
 *
 * ### ⚠ Bileşen yalnız SÖYLÜYOR
 *
 * Seçim listesinin kendisi çağıran ekranda kalıyor; burada tek iş, listenin neden boş
 * olduğunu anlatmak. Altı çağrı yerinde aynı cümleyi elle yazsaydık, biri gün gelip
 * diğerlerinden ayrışırdı.
 */
export function UyeListesiDurumu({
  hata,
  bosMu,
  bosMesaj = "Bu çalışma alanında seçilebilecek aktif kullanıcı yok.",
}: {
  hata: unknown;
  bosMu: boolean;
  bosMesaj?: string;
}) {
  if (hata) {
    return (
      <p className="text-xs text-fg-soft">
        Kullanıcı listesi getirilemedi: bu çalışma alanındaki kişileri görme yetkiniz olmayabilir.
        Yetki için organizasyon yöneticinizle görüşün.
      </p>
    );
  }

  if (bosMu) return <p className="text-xs text-fg-soft">{bosMesaj}</p>;

  return null;
}
